import { Box, Grid } from '@material-ui/core';
import { StyledEmptyMessage } from 'components/Notifications/styles';
import messages from 'components/Notifications/messages';
import { AssuranceIcon } from 'images';
import React from 'react';
import { useIntl } from 'react-intl';

const NotificationEmptyBloc = () => {
  const { formatMessage } = useIntl();
  return (
    <Box padding={8}>
      <Grid
        container
        alignItems="center"
        justify="center"
        direction="column"
        spacing={2}
      >
        <Grid item>
          <img alt="no-notifications" src={AssuranceIcon.noNotifications} />
        </Grid>
        <StyledEmptyMessage>
          {formatMessage(messages.empty_message)}
        </StyledEmptyMessage>
      </Grid>
    </Box>
  );
};

export default NotificationEmptyBloc;
